import classnames from 'classnames';
import { darkModeAware } from '@glu/theming';
import useStyles from './LengthIndicator.styles';

export interface ILengthIndicatorProps {
  /** Display with dark mode styling? */
  dark?: boolean;
  /** Should display with error styling? */
  hasError?: boolean;
  /** The maximum length the input should receive */
  maxLengthIndicatorLimit?: number;
  /** The value of the input field. Used to compare the current
   * length of the value to the max length
   */
  value?: string | number;
}

const LengthIndicator = ({
  dark,
  hasError,
  maxLengthIndicatorLimit,
  value,
}: ILengthIndicatorProps) => {
  const classes = useStyles();

  return maxLengthIndicatorLimit ? (
    <p
      className={classnames(classes.root, {
        [classes.dark]: dark,
        [classes.error]: hasError,
      })}
    >
      {value ? value.toString().length : 0}/{maxLengthIndicatorLimit}
    </p>
  ) : null;
};

export const BareLengthIndicator = LengthIndicator;
export default darkModeAware(LengthIndicator);
